import { Card, Group, Text, Stack } from "@mantine/core";

export type DashboardStatsProps = {
  passRate: number;
  totalTests: number;
  activeWelders: number;
  weldersExpired: number;
};

export function DashboardStats({ passRate, totalTests, activeWelders, weldersExpired }: DashboardStatsProps) {
  return (
    <Group grow>
      <Card>
        <Stack align="center" gap={0}>
          <Text size="3rem" fw={700} mb={10}>
            {passRate}%
          </Text>
          <Text size="sm">PASS RATE</Text>
        </Stack>
      </Card>
      <Card>
        <Stack align="center" gap={0}>
          <Text size="3rem" fw={700} mb={10}>
            {totalTests}
          </Text>
          <Text size="sm">TOTAL TESTS RUN</Text>
        </Stack>
      </Card>
      <Card>
        <Stack align="center" gap={0}>
          <Text size="3rem" fw={700} mb={10}>
            {activeWelders}
          </Text>
          <Text size="sm">ACTIVE WELDERS</Text>
        </Stack>
      </Card>
      <Card>
        <Stack align="center" gap={0}>
          <Text size="3rem" fw={700} mb={10}>
            {weldersExpired}
          </Text>
          <Text size="sm">WELDERS EXPIRED</Text>
        </Stack>
      </Card>
    </Group>
  );
}
